import $http from '../api/http'

const globalSite = {
  // 获取认证token
  async getToken (params) {
    return $http('/auth/token', {
      method: 'POST',
      data: { ...params }
    });
  },
  // 获取用户信息
  async getProfile () {
    return $http('/api/users/profile');
  }
};

export default globalSite;



// WEBPACK FOOTER //
// ./src/api/globalSite.js